import { gql } from '@apollo/client/core'

export const productSearchQuery = gql`
  query getSearchProducts(
    $categoryIds: [ID!]
    $minUnitPrice: Int
    $maxUnitPrice: Int
    $quantity: Int
    $printingMethod: String!
    $orderMethod: String!
    $facets: [String!]
    $keyword: String!
    $offset: Int!
    $limit: Int!
    $sortOrder: String!
    $favorite: Boolean
  ) {
    productSearchResults(
      categoryIds: $categoryIds
      maxUnitPrice: $maxUnitPrice
      minUnitPrice: $minUnitPrice
      quantity: $quantity
      printingMethod: $printingMethod
      facets: $facets
      keyword: $keyword
      offset: $offset
      limit: $limit
      sortOrder: $sortOrder
      orderMethod: $orderMethod
      favorite: $favorite
    ) {
      totalItemsCount
      items {
        id
        productId
        psi
        categoryId
        displayName
        quantityUnit
        firstSelectionOptionLabel
        firstSelectionOptionValue
        firstSelectionOptionTotal
        secondSelectionOptionLabel
        secondSelectionOptionValue
        secondSelectionOptionTotal
        minProductCampaignPrice
        maxProductCampaignPrice
        minProductQuantity
        maxProductQuantity
        minProductPrice
        maxProductPrice
        skuImage
        printTag
        allowTrial
      }
      printingMethod {
        full
        single
      }
      orderMethod {
        plain
        trial
      }
      facets {
        facetKeyName
        facetKeyId
        facetKeyDisplayName
        facetType
        canonicalSetting
        count
        facetKeyDisplayOrder
        facetValues {
          count
          facetValueName
          facetValueId
          facetValueDisplayOrder
          facetValueDisplayName
        }
      }
      categories {
        id
        topSearchCount
        childCategories {
          id
          topSearchCount
          childCategories {
            id
            topSearchCount
          }
        }
      }
    }
  }
`
export const estimateProductSearchQuery = gql`
  query getEstimateSearchProducts(
    $categoryIds: [ID!]
    $minUnitPrice: Int!
    $maxUnitPrice: Int!
    $quantity: Int
    $printingMethod: String!
    $orderMethod: String!
    $facets: [String!]
    $offset: Int!
    $limit: Int!
    $sortOrder: String!
  ) {
    productSearchResults(
      categoryIds: $categoryIds
      maxUnitPrice: $maxUnitPrice
      minUnitPrice: $minUnitPrice
      quantity: $quantity
      printingMethod: $printingMethod
      orderMethod: $orderMethod
      facets: $facets
      offset: $offset
      limit: $limit
      sortOrder: $sortOrder
    ) {
      totalItemsCount
    }
  }
`
